// Builds the payload the betslip endpoint expects from the picks the scanner
// returns. Two traps this covers:
//
// 1. The scanner names the chosen bet `selection`; the endpoint expects `sel`
//    and rejects an empty one, which left the visitor stuck on
//    "Faltan datos de la selección" right after a successful read.
// 2. Production validates every odd against the live feed. The names read from
//    a photo rarely match the feed spelling, so whenever our own search already
//    resolved the event we send its names and identifiers instead.

function firstFilled(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

export function betslipPicks(picks) {
  return (picks || [])
    .filter((pick) => pick && pick.odd_final)
    .map((pick) => {
      // `sel` es lo que viaja a la venta, así que gana `pick.nombre` —el
      // nombre que EMITE GR8, que lo pone el corrector de picks— sobre
      // `pick.selection`, que es la etiqueta de pantalla. Es el mismo orden
      // que `normalizarPicks` en `App.jsx` y `cargarMejora` en `Box.jsx`.
      //
      // El índice de claves de selección está armado con lo que emite el
      // feed ("Draw", "Over 2", el nombre pelado del equipo). La etiqueta no
      // está ahí, así que el boleto se emitía —el prefijo `gr8_` le alcanza a
      // la validación de venta— y fallaba recién al liquidar: quedaba
      // `otro_proveedor` y lo pagaba una persona a mano.
      //
      // `nombre` vacío cae en la etiqueta, como antes: el repliegue viejo no
      // lee el diccionario del emisor y ahí no hay ninguna clave que mandar.
      const payload = {
        home: firstFilled(pick.home_real, pick.home, pick.h),
        away: firstFilled(pick.away_real, pick.away, pick.a),
        sel: firstFilled(pick.nombre, pick.selection, pick.sel, pick.seleccion,
          pick.label),
        odd: pick.odd_final,
        sport: firstFilled(pick.sport),
      };
      const eventId = firstFilled(pick.event_id, pick.id);
      const sportKey = firstFilled(pick.sport_key);
      const market = firstFilled(pick.market);
      const commenceTime = firstFilled(pick.commence_time);
      if (eventId) payload.event_id = eventId;
      if (sportKey) payload.sport_key = sportKey;
      if (market) payload.market = market;
      if (commenceTime) payload.commence_time = commenceTime;
      return payload;
    });
}

export default betslipPicks;
